import React, { useState } from "react";

// ESRI Components
import Extent from "@arcgis/core/geometry/Extent";

// Import Semantic UI React
import { Dropdown, Popup, TransitionablePortal } from "semantic-ui-react";

export default function BookmarkWidget(props) {
  const [hover, setHover] = useState(false);
  const [open, setOpen] = useState(false);

  return (
    <Popup
      trigger={
        <Dropdown
          icon="bookmark"
          pointing="left"
          className="ui icon button no-margin no-focus"
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <Dropdown.Menu>
            <Dropdown.Header content="Bookmarks" />
            <Dropdown.Divider />
            {renderList()}
            <Dropdown.Divider />
            {/* <Dropdown.Item onClick={() => props.renderZoomToXyWidget()}>
          <Icon className="esri-icon-plus icon" />
          Zoom to XY
        </Dropdown.Item> */}
          </Dropdown.Menu>
        </Dropdown>
      }
      className={`transition fade ${hover && !open ? "in" : "out"}`}
      on={"hover"}
      open={hover && !open}
      inverted
      size="tiny"
      content="Bookmarks"
      position="right center"
    />
  );

  function handleClick(extent) {
    props.view.goTo(new Extent(extent));
  }

  function renderList() {
    return default_bookmarks.map((bookmark, index) => {
      return (
        <Dropdown.Item key={index} onClick={() => handleClick(bookmark.extent)}>
          {bookmark.label}
        </Dropdown.Item>
      );
    });
  }
}

const default_bookmarks = [
  {
    label: "Des Moines Country",
    extent: {
      xmin: 2170244.54269575,
      ymin: 257059.937828542,
      xmax: 2421112.5982513,
      ymax: 408622.43782854,
      spatialReference: {
        wkid: 3418,
      },
    },
  },
  {
    label: "Burlington",
    extent: {
      xmin: 2267399.49061241,
      ymin: 290417.14268965,
      xmax: 2322633.86561241,
      ymax: 316940.58018965,
      spatialReference: {
        wkid: 3418,
      },
    },
  },
  {
    label: "West Burlington",
    extent: {
      xmin: 2269629.95936241,
      ymin: 300351.17046743,
      xmax: 2298036.20936241,
      ymax: 313991.79546743,
      spatialReference: {
        wkid: 3418,
      },
    },
  },
  {
    label: "Middletown",
    extent: {
      xmin: 2253176.83436241,
      ymin: 306747.00380076,
      xmax: 2265801.83436241,
      ymax: 312809.50380076,
      spatialReference: {
        wkid: 3418,
      },
    },
  },
  {
    label: "Danville",
    extent: {
      xmin: 2234758.86561241,
      ymin: 316230.36606928,
      xmax: 2254485.42811241,
      ymax: 325703.02231928,
      spatialReference: {
        wkid: 3418,
      },
    },
  },
  {
    label: "Mediapolis",
    extent: {
      xmin: 2279001.48714019,
      ymin: 373189.56745817,
      xmax: 2291626.48714019,
      ymax: 379252.06745817,
      spatialReference: {
        wkid: 3418,
      },
    },
  },
];
